import { React, useState, useEffect } from 'react'
import CommonModal from '../../UI/UIComponent/Modal/CommonModal'
import ConsultationBooking from '../../FeatureComponent/QuickBooking/consultationBooking'
import OtpModal from '../../UI/UIComponent/Modal/OtpModal'
import Header from '../../Layout/Header'
import NonCarouselBanner from '../../UI/Banner/NonCarouselBanner'
import hospitalImage from '../../assets/Images/hospitalPage/hospital-banner-image.webp'
import DietPlanBanner from '../../UI/Global-Component/DietPlanBanner'
import PaginationComponent from '../../UI/Global-Component/paginationComponent'
import Footer from '../../Layout/Footer'
import HospitalDetailCard from './components/HospitalDetailCard'
import { getAllHospitals } from '../../api/services/hospital-service';

export default function HospitallistingPage() {
  const [patientPayload, setpatientPayload] = useState({})
  const [encodedData, setEncodeddata] = useState()
  const [hospitalList, setHospitalsList] = useState([])
  const [dataLength, setDataLength] = useState()
  const [pageNumber, setPageNumber] = useState(1)

  const handleBookAppointment = () => {
    let modalRef = document.getElementById('consultation-modal')
    modalRef.classList.add('show')
  }
  const handleCallback = (childData) => {
    setpatientPayload({ ...childData })
    setEncodeddata(childData.encodedData)
  }
  useEffect(() => {
    fetchAllHospitals(pageNumber)
  }, [])
  const fetchAllHospitals = (page) => {
    getAllHospitals(page).then((result) => {
      setHospitalsList(result.data)
      setDataLength(result.totalHospitalCount);
    })
  }
  const handlePaginationChange = (page) => {
    const selectedPage = parseInt(page.target.textContent)
    setPageNumber(selectedPage)
    fetchAllHospitals(selectedPage)
    document.documentElement.scrollTop = 400
  }
  const handleEnquireBtnClick = () => {
    let modalRef = document.getElementById('consultation-modal')
    modalRef.classList.add('show')
  }
  return (
    <>
      <CommonModal></CommonModal>
      <ConsultationBooking
        parentCallback={handleCallback}
      ></ConsultationBooking>
      <OtpModal
        patientInfoPayload={patientPayload}
        patientEncodedData={encodedData}
      ></OtpModal>
      <Header pageId={'3'}></Header>
      <section>
        <NonCarouselBanner
          ImageSrc={hospitalImage}
          imageAlt="RHS Hospital Addmission"
          buttonOnclick={handleBookAppointment}
          heading="The Rever Health Solution"
          Subheading="Consult Our Trusted Surgeons, Book an Appointment"
          footNote="The best of modern healthcare to ensure you stay healthy, always."
        ></NonCarouselBanner>
        <div className="container-fluid">
          <div className="container doctor-detail">
            <h2>Top Associate Hospitals Available</h2>
            {/* <DoctorFacetSearch
              selectedItem={handleCategoryFilter}
            ></DoctorFacetSearch> */}
            <div className="body-section">
              {hospitalList.length !== 0 ? (
                <div className="card-stack">
                  {hospitalList.map((data, index) => (
                    <HospitalDetailCard
                      Heading={data.websiteDisplayName}
                      subHead={data.websiteDisplayAddress}
                      imageVal={data.HospitalPhoto}
                      handlenqrNwBtnClick={handleEnquireBtnClick}
                    ></HospitalDetailCard>
                  ))}
                </div>
              ) : (
                <div className="card-stack">
                  <p>No Doctor Available</p>
                </div>
              )}
              <DietPlanBanner></DietPlanBanner>
            </div>
          </div>
        </div>
        <PaginationComponent
          pageLength={dataLength}
          paginationChange={handlePaginationChange}
          selectedPagination={pageNumber}
        ></PaginationComponent>
        <Footer></Footer>
      </section>
    </>
  )
}
